import moment from 'moment-timezone';
import { LegFiJwtService } from '../../services/auth/legfi-jwt.service';
import { Budget } from './budget';
import { Category } from './accounting/category';
import Moment = moment.Moment;

export class BudgetItem
{
    id: number;
    budgetId: number;
    categoryId: number;
    amount: number;
    month: number;
    year: number;
    createdAt: Moment;
    updatedAt: Moment;

    budget: Budget;
    category: Category;

    constructor(budgetItem: any) {
        if (budgetItem.id) {
            this.id = budgetItem.id;
        }
        if (budgetItem.budgetId) {
            this.budgetId = budgetItem.budgetId;
        }
        if (budgetItem.categoryId) {
            this.categoryId = budgetItem.categoryId;
        }
        this.amount = budgetItem.amount || 0;
        if (budgetItem.month) {
            this.month = budgetItem.month;
        }
        if (budgetItem.year) {
            this.year = budgetItem.year;
        }

        const timezone = LegFiJwtService.getTimezone();
        if (budgetItem.createdAt) {
            this.createdAt = moment.utc(budgetItem.createdAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }
        if (budgetItem.updatedAt) {
            this.updatedAt = moment.utc(budgetItem.updatedAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }

        if (budgetItem.budget) {
            this.budget = new Budget(budgetItem.budget);
        }
        if (budgetItem.category) {
            this.category = new Category(budgetItem.category);
        }
    }
}
